import { render, staticRenderFns } from "./SuspendComponent.vue?vue&type=template&id=0081ecd4&scoped=true"
import script from "./SuspendComponent.vue?vue&type=script&lang=js"
export * from "./SuspendComponent.vue?vue&type=script&lang=js"
import style0 from "./SuspendComponent.vue?vue&type=style&index=0&id=0081ecd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0081ecd4",
  null
  
)

export default component.exports